<script>
  import axios from 'axios'
  import { DateTime } from 'luxon'

  import LoadingIndicator from '../components/LoadingIndicator.svelte'
  import Input from '../components/googleForm/Input.svelte'
  import ButtonListInput from '../components/googleForm/ButtonListInput.svelte'

  import constants from '../../../functions/constants'
  const { SERVICE_URLS } = constants
  import globalConstants from '../../../functions/globalConstants'
  const {
    ATTENDANCE_OUTPUT_FOLDER,
    INSPECTION_OUTPUT_FOLDER,
    INVOICE_OUTPUT_FOLDER,
  } = globalConstants

  const ledgers = [
    {
      name: '出勤簿',
      kind: 'attendance',
      folder: ATTENDANCE_OUTPUT_FOLDER,
    },
    {
      name: '日常点検基準表',
      kind: 'inspection',
      folder: INSPECTION_OUTPUT_FOLDER,
    },
    {
      name: 'ダンプ 請求書',
      kind: 'dumpInvoice',
      folder: INVOICE_OUTPUT_FOLDER,
    },
    {
      name: 'カシケン 請求書',
      kind: 'invoice',
      folder: INVOICE_OUTPUT_FOLDER,
      client: 'カシケン',
    },
    {
      name: '豊田工業 請求書',
      kind: 'invoice',
      folder: INVOICE_OUTPUT_FOLDER,
      client: '豊田工業',
    },
  ]

  // 年月初期値
  let dateQuery = DateTime.local().minus({ month: 1 }).toFormat('yyyy-MM')

  // 入力ボックスで選択中の帳票名
  let selectedLedgerName

  // 選択中の帳票
  $: selectedLedger = selectedLedgerName
    ? ledgers.find(ledger => ledger.name === selectedLedgerName)
    : undefined

  // 入力日付のパース
  $: date = DateTime.fromFormat(dateQuery, 'yyyy-MM')

  // AJAX応答待ち用のpromise
  let promise

  // リクエストをPOSTする
  const request = () => {
    // リクエストpromiseを生成してセットする
    promise = axios
      .post(
        // `https://www.google.com`, // エラーテスト用URL
        SERVICE_URLS.GENERATE_LEDGERS,
        {
          ledger: selectedLedger.kind,
          year: date.year,
          month: date.month,
          client: selectedLedger.client,
        },
        { timeout: 1000 * 60 }
      )
      .then(res => {
        console.log(res)
      })
      .catch(e => {
        console.error(e)
        throw e
      })
  }
</script>

<section class="box">
  <h1>帳票 出力</h1>

  {#if !promise}
    <!-- 処理前UI -->
    <div class="columns">
      <div class="column is-2">
        <ButtonListInput
          id="selectLedger"
          name="selectLedger"
          label="帳票を選択"
          list={ledgers.map(ledger => ledger.name)}
          bind:value={selectedLedgerName}
        />
      </div>

      <div class="column is-2">
        <Input
          type="month"
          id="dateQuery"
          name="dateQuery"
          label="対象年月を選択"
          bind:value={dateQuery}
        />
      </div>
    </div>

    <p>
      <button
        id="submitButton"
        type="submit"
        class="button is-link"
        data-testid="submitButton"
        disabled={!selectedLedger}
        on:click={request}
      >
        出力 開始
      </button>
    </p>
  {:else}
    <!-- 処理開始後UI -->
    <p data-testid="requestedMonth">{date.year} 年 {date.month} 月分</p>

    <div data-testid="exportProgress">
      {#await promise}
        <p><LoadingIndicator>出力中...</LoadingIndicator></p>
      {:then}
        <p>出力 完了</p>
      {:catch error}
        <p style="color: red">出力が時間内に終わりませんでした。</p>
        <p>出力フォルダをご確認になり、問題があればご連絡下さい。</p>
        <p>エラー内容:</p>
        <p>{JSON.stringify(error, null, '  ')}</p>
      {/await}
    </div>
  {/if}

  <!-- 出力フォルダへのリンク -->
  {#if selectedLedger}
    <p>
      <a
        data-testid="folderLink"
        href={`https://drive.google.com/drive/folders/${selectedLedger.folder}`}
      >
        → 出力結果はこちらのフォルダからご確認ください ←
      </a>
    </p>
  {/if}
</section>
